'use strict';


var oldHref = document.location.href;
const windowLocationHref = window.location.href;
const url = new URL(windowLocationHref);
const origin = url.searchParams.get('origin');


document.addEventListener('DOMContentLoaded', () => {

  if (!origin) {

    const menuAutomation = document.getElementById('menuAutomation');
    const pagePricigin = document.querySelector('.page-pricing-main');
    const footerDinamicBtn = document.getElementById('footerDinamicBtn');

    //Pricing origins

    if (pagePricigin && document.querySelector('.plan-calculator')) {
      const bodyList = document.querySelector("body")

      const changeBtnHash = (currentHash) => {
        const pricingBtn = document.querySelector('.tab--content.active .plans-cta-container a');
        let oldHrefOrigin = pricingBtn.href.split('&origin')[0];
        currentHash = currentHash.replace("#", "");
        pricingBtn.href = oldHrefOrigin + '&origin=' + currentHash.trim();
      }


      const onLoadHash = document.querySelector('.tab--link.active').parentElement.getAttribute('data-name');
      changeBtnHash(onLoadHash);

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (oldHref != document.location.href) {
            oldHref = document.location.href;
            if (window.location.hash) {
              changeBtnHash(window.location.hash);
            }
          }
        });
      });

      const config = {
        childList: true,
        subtree: true
      };

      observer.observe(bodyList, config);

    }


    //Functionalities origins
    if (menuAutomation) {

      const menuOnLoad = menuAutomation.querySelector('a.active').getAttribute('data-href');
      changeBtnsHref(menuOnLoad);

      const menuAutomationItems = menuAutomation.querySelectorAll('a');
      menuAutomationItems.forEach(itemMenu => {
        itemMenu.addEventListener('click', () => {
          let newOrigin = itemMenu.getAttribute('data-href');
          changeBtnsHref(newOrigin);
        });
      });

      function changeBtnsHref(newOrigin) {
        document.querySelectorAll('section .button').forEach((btn, index) => {
          if (btn.tagName === 'A') {
            let oldHrefOrigin = btn.href.split('&origin')[0];
            btn.href = oldHrefOrigin + '&origin=' + newOrigin + (index + 1);
          }
        });
      }

    }

    //Footer component origins

    if (footerDinamicBtn) {

      let windowPathName = window.location.pathname;
      const oldButtonHref = footerDinamicBtn.href;
      if (document.documentElement.lang === 'es') {
        windowPathName = windowPathName.split('/es/')[1];
        windowPathName = windowPathName.split('/')[0];
      } else {
        windowPathName = windowPathName.split('/en/')[1];
        windowPathName = windowPathName.split('/')[0];
      }
      footerDinamicBtn.href = oldButtonHref + '&origin=' + windowPathName;

    }

  }
});

